import React, { useEffect, useState } from "react";
import DeveloperModeIcon from "@material-ui/icons/DeveloperMode";
import CodeIcon from "@material-ui/icons/Code";
import WebIcon from "@material-ui/icons/Web";
// import DesignServicesIcon from '@mui/icons-material/DesignServices';
// import CodeIcon from '@mui/icons-material/Code';
// import WebIcon from '@mui/icons-material/Web';
import "./Services.css";

function Services() {
  const [scroll, setScroll] = useState(0);

  function handleScroll(event) {
    setScroll(window.scrollY - 2250);
    // console.log(window.scrollY)
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      style={{
        // backgroundColor: "#211530",
        padding: "0px 76px 80px 76px",
      }}
      className="client-review-container-top"
    >
      <div className="scroll-text">
        <p className="" style={{ transform: `translateX(${scroll}%)` }}>
          SERVICES
        </p>
      </div>
      <h2
        style={{
          color: "#00ffd5",
          textAlign: "center",
          marginTop: "-60px",
          marginBottom: "80px",
          fontSize: "36px",
          position: "relative",
          zIndex: 2,
          fontWeight: "bold",
        }}
      >
        MY SERVICES
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "16px",
          }}
        >
          <div className="main">
            <div className="ball"></div>
          </div>
        </div>
      </h2>

      <div
        className="row container-fluid"
        style={{
          marginTop: "60px",
          width: "100%",
          marginLeft: "0",
          marginRight: "0",
        }}
      >
        <div class="card-deck">
          <div
            class="card"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="0"
          >
            {/* <img class="card-img-top" src="..." alt="Card image cap" > </img> */}

            <div class="card-body">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="service-card-icon">
                  <DeveloperModeIcon />
                </div>

                <h1 className="service-card-header-text"> 01 </h1>
              </div>
              <h5 class="card-title">Frontend Development</h5>
              <p class="card-text">
                I provide comprehensive frontend development services, utilizing
                the latest technologies and design principles to create visually
                appealing and user-friendly web experiences for clients.
              </p>
            </div>
          </div>
          <div
            class="card"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="300"
          >
            {/* <img class="card-img-top" src="..." alt="Card image cap"> */}
            <div class="card-body">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="service-card-icon">
                  <CodeIcon />
                </div>

                <h1 className="service-card-header-text"> 02 </h1>
              </div>
              <h5 class="card-title">MERN Stack Development</h5>
              <p class="card-text">
                I provide comprehensive MERN development services, utilizing the
                latest technologies in MongoDB, Express, React, and Node.js to
                build custom and scalable web applications.
              </p>
            </div>
          </div>
          <div
            class="card"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="600"
          >
            {/* <img class="card-img-top" src="..." alt="Card image cap"> */}
            <div class="card-body">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="service-card-icon">
                  <WebIcon />
                </div>

                <h1 className="service-card-header-text"> 03 </h1>
              </div>
              <h5 class="card-title">Mobile App Development</h5>
              <p class="card-text">
                I provide comprehensive mobile app development services to help
                businesses build high-performance, user-friendly, and scalable
                mobile applications that drive growth and enhance customer
                experiences.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
